import React from 'react'
import { Banner } from '@core/Components/Banner'
import { MainContainer } from '@core/Components/Containers/MainContainer'
import { MeetingsList, PrimaryDateNavigation, SecondaryCodeNavigation } from './Components'
import { useMeetingsData } from './hooks'

export const MeetingsPage: React.FC = () => {
  const { state, handlers, data } = useMeetingsData()

  return (
    <MainContainer background='grey' testId='meetings'>
      <Banner areaName='Meetings' />

      <PrimaryDateNavigation data={data} state={state} handlers={handlers} />
      <SecondaryCodeNavigation state={state} />

      <MeetingsList data={data} state={state} />
    </MainContainer>
  )
}
